var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesafiosEventos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65167 0C4.23167 0 0.651672 0.5 0.651672 4V14C0.651672 14.88 1.04167 15.67 1.65167 16.22V18C1.65167 18.55 2.10167 19 2.65167 19H3.65167C4.20167 19 4.65167 18.55 4.65167 18V17H12.6517V18C12.6517 18.55 13.1017 19 13.6517 19H14.6517C15.2017 19 15.6517 18.55 15.6517 18V16.22C16.2617 15.67 16.6517 14.88 16.6517 14V4C16.6517 0.5 13.0717 0 8.65167 0ZM14.3117 2.99H2.99167C3.54167 2.46 4.96167 2 8.65167 2C12.3417 2 13.7617 2.46 14.3117 2.99ZM14.6517 4.99V8H2.65167V4.99H14.6517ZM14.3117 14.73L14.0217 15H3.28167L2.99167 14.73C2.86167 14.62 2.65167 14.37 2.65167 14V10H14.6517V14C14.6517 14.37 14.4417 14.62 14.3117 14.73Z",
    fill: "#4318FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesafiosEventos);
export default __webpack_public_path__ + "static/media/desafios-eventos.7520eb599f5779dce29a4cde85e333c0.svg";
export { ForwardRef as ReactComponent };